var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
var LabelContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n"], ["\n    display: flex;\n"])));
export var StyledLabel = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: block;\n    margin-bottom: ", ";\n    margin-right: ", ";\n    ", ";\n"], ["\n    display: block;\n    margin-bottom: ", ";\n    margin-right: ", ";\n    ", ";\n"])), function (_a) {
    var isHorizontal = _a.isHorizontal;
    return (isHorizontal ? 0 : '0.5em');
}, function (_a) {
    var isHorizontal = _a.isHorizontal;
    return (isHorizontal ? '0.5em' : 0);
}, function (_a) {
    var isSmall = _a.isSmall;
    return isSmall && 'font-size: 12px';
});
var StyledDescription = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: block;\n    margin-bottom: ", ";\n    margin-right: ", ";\n    ", ";\n"], ["\n    display: block;\n    margin-bottom: ", ";\n    margin-right: ", ";\n    ", ";\n"])), function (_a) {
    var isHorizontal = _a.isHorizontal;
    return (isHorizontal ? 0 : '0.5em');
}, function (_a) {
    var isHorizontal = _a.isHorizontal;
    return (isHorizontal ? '0.5em' : 0);
}, function (_a) {
    var isSmall = _a.isSmall;
    return isSmall && 'font-size: 12px';
});
export var Label = function (_a) {
    var text = _a.text, description = _a.description, className = _a.className, isHorizontal = _a.isHorizontal, isSmall = _a.isSmall, rest = __rest(_a, ["text", "description", "className", "isHorizontal", "isSmall"]);
    return (React.createElement(LabelContainer, { className: className },
        text && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        React.createElement(StyledLabel, __assign({ isHorizontal: isHorizontal, isSmall: isSmall }, rest), text)),
        description && (React.createElement(StyledDescription, { isHorizontal: isHorizontal, isSmall: isSmall }, description))));
};
var templateObject_1, templateObject_2, templateObject_3;
